import React from 'react';

/**
 * SkipToMain - Accessibility component that allows keyboard users to 
 * bypass navigation menus and go directly to the main content.
 * 
 * This component is visually hidden until it receives focus, making it 
 * available only to keyboard users who need it.
 */
export const SkipToMain: React.FC = () => {
  return (
    <a 
      href="#main-content" 
      className="skip-to-content"
      // Add explicit aria attributes for screen readers
      aria-label="Skip to main content"
    >
      Skip to main content
    </a>
  );
};

export default SkipToMain; 